import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import AIToolsSidebar from '../components/AIToolsSidebar';
import { useUser } from '../contexts/UserContext';
import './AIImprovementPage.css';

const AIImprovementPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData, loading } = useUser();

  const userPlan = userData?.planType || 'free';

  // If user lands on /ai-improvement without a sub-route, redirect to toolkit (if accessible)
  useEffect(() => {
    if ((location.pathname === '/ai-improvement' || location.pathname === '/ai-improvement/') && !loading) {
      const hasToolkitAccess = ['gold', 'platinum'].includes(userPlan);
      
      if (hasToolkitAccess) {
        navigate('/ai-improvement/ai-career-toolkit', { replace: true });
      } else {
        // If no access to any tool, redirect to pricing
        navigate('/pricing', { replace: true });
      }
    }
  }, [location.pathname, navigate, userPlan, loading]);

  return (
    <div className="ai-improvement-container">
      <AIToolsSidebar isVisible={true} />
      <div className="ai-improvement-content">
        <Outlet context={{ userPlan }} />
      </div>
    </div>
  );
};

export default AIImprovementPage;
